import $ from "jquery";
import Backbone from "backbone";
import _ from "underscore";
import mapCacheService from "./mapCacheService";
import { lang, region } from "../others/Configuration";

function getMapLocationApiUrl(search) {
  search = search.toString().toLowerCase().trim();
  let countryCode = region;

  // Hacks
  switch (countryCode) {
    case "FR":
      search = (search === "98000" || search === "monaco") ? "98000 Monaco" : search;
      search = encodeURIComponent(search);
      break;
    case "BE":
      countryCode = (search === "luxembourg") ? "LU" : countryCode;
      search = encodeURIComponent(search);
      break;
    case "CH":
      // WTF Bing with Suiss postcodes ???
      switch (search) {
        case "1002":
          search = "1002/Lausanne/Switzerland";
          break;
        case "1211": // Gen�ve
          search = "1211/Geneva/Switzerland";
          break;
        case "1700":
          search = "1700/Fribourg/Switzerland";
          break;
        case "1964":
          search = "1964/Conthey/Switzerland";
          break;
        case "2000": // Neufch�tel
          search = "2000/Neuchatel/Switzerland";
          break;
        // Maybe we'll need Zurich, Basel (B�le) and Bern (Berne)...
        default:
          search = encodeURIComponent(search);
      }
  }

  // We use "Structured URL" to restrict search to a country coz "Unstructured URL" is not accurate
  // https://docs.microsoft.com/en-us/bingmaps/rest-services/locations/find-a-location-by-query
  return 'https://dev.virtualearth.net/REST/v1/Locations/' + countryCode + '/' + search + '?maxResults=1';
}

// Similar to jquery jsonp
// https://github.com/jquery/jquery/blob/3d732cca6b5076a9d13eee98e2b075b37384cd91/src/ajax/jsonp.js#L18
// https://github.com/jquery/jquery/blob/4ffb1df8e4738eb86bde429ec20efc7394e5e497/src/core.js#L199
var callbackName = "mapServiceCallback" + Math.random().toString().replace(/\D/g, "") + "_" + Date.now();

// Bing map api, available parameters are branch, callback and UR (User Region)
var MAP_SERVICE_URL = 'https://www.bing.com/api/maps/mapcontrol?callback=' + callbackName;
var MAP_SERVICE_CREDENTIALS = {
  'nav_store_locator': 'AjRBuc0Hyy_6A8_rT3AoG6tLX3NuFBsCq0t5Y5MB2WxhnKbYDOBQk9HtaCDfDxL0',
  'nav_search_mag': 'mRb5onLuWjx7mmBSZnUU~FO2JxQ2izTCJps_rse-9bQ~AuFhcYTZmUzaYXUTIP5h6YqN9pzQZ86QS12AwL1UeJR80wAlAmvocRvz1dc0_36p',
  'pipe_search_mag': 'AmN4JBlc_j9hHCqaNjG8RbBizw6X0JBupviYDn4_AJKEIYq95JLxzOEWDr9cKncU'
};
var MAP_SERVICE_CREDENTIALS_SESSION = null;

var MAP_ZOOM_COUNTRY = 8;
var MAP_ZOOM_CITY = 14;
var MAP_OGRANIZATIONS = {
  'FNAC': 0,
  'DARTY': 1
};
var COUNTRY_OPTION = {
  'FR': {
    zoom: 5,
    latitude: 46.227638,
    longitude: 2.213749
  },
  'ES': {
    zoom: 5,
    latitude: 40.463667,
    longitude: -3.74922
  },
  'PT': {
    zoom: 6,
    latitude: 39.399872,
    longitude: -8.224454
  },
  'CH': {
    zoom: 7,
    latitude: 46.818188,
    longitude: 8.227512
  },
  'BE': {
    zoom: 7,
    latitude: 50.503887,
    longitude: 4.469936
  }
};

var mapServiceLoaded = false;
var mapOptions = {};
var mapService = _.extend({}, Backbone.Events);
var mapId = null;
var mapSearchManager = null;
var maps = {};
maps.entities = [];

export default mapService;

// We need to create a specific window function to manage callback with Bing Maps
window[callbackName] = function () {
  delete window[callbackName];
  mapServiceLoaded = true;
  mapService.trigger('load:' + mapId);
};

mapService.load = function (id) {
  mapId = id;

  if (mapServiceLoaded) {
    mapService.trigger('load:' + mapId);
    return;
  }

  var script = document.createElement('script');
  script.src = MAP_SERVICE_URL;
  document.getElementsByTagName('head')[0].appendChild(script);
};

mapService.create = function (el, options) {
  options = options || {};

  if (typeof maps.entities !== 'undefined' && maps.entities.length > 0) {
    _.each(maps.entities, function (entity, index) {
      if (entity.map && entity.id === mapId) {
        return entity.map;
      }
    });
  }

  options.credentials = MAP_SERVICE_CREDENTIALS['nav_store_locator'];
  options.mapTypeId = Microsoft.Maps.MapTypeId.road;
  if (COUNTRY_OPTION[lang]) {
    options.zoom = COUNTRY_OPTION[lang].zoom;
    options.center = new Microsoft.Maps.Location(COUNTRY_OPTION[region].latitude, COUNTRY_OPTION[lang].longitude);
  } else {
    options.zoom = 12;
  }
  options.disableBirdseye = true;
  options.enableSearchLogo = false;
  options.showDashboard = false;
  options.showMapTypeSelector = false;

  maps.entities.push({ id: mapId, map: new Microsoft.Maps.Map(el, options) });
  return maps.entities[maps.entities.length - 1].map;
};

mapService.getCredentials = function (env) {
  var credentialDeferred = $.Deferred();
  if (typeof maps.entities !== 'undefined' && maps.entities.length > 0) {
    _.each(maps.entities, function (entity, index) {
      if (entity.map && entity.id === mapId) {
        entity.map.getCredentials(
          function (sessionKey) {
            credentialDeferred.resolve(sessionKey);
          }
        );
      }
    });
  } else {
    credentialDeferred.resolve(MAP_SERVICE_CREDENTIALS[env]);
  }
  return credentialDeferred.promise();
};

mapService.search = function (map, query, callback) {
  if (!mapSearchManager) {
    Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
      mapSearchManager = new Microsoft.Maps.Search.SearchManager(map);
      mapService.search(map, query, callback);
    });
  } else {
    var options = {
      bounds: map.getBounds(),
      where: query,
      callback: function (response) {
        var results = response.results;
        var location = null;

        if (results.length) {
          location = {
            latitude: results[0].location.latitude,
            longitude: results[0].location.longitude
          }
        }

        callback(location);
      },
      errorCallback: function () {
        callback(null);
      }
    };

    mapSearchManager.geocode(options);
  }
};

/**
 * @see {@link https://msdn.microsoft.com/en-us/library/ff701714.aspx }
 */
mapService.geocode = function (search, params, env) {
  return mapCacheService.get(search).then(
    function (result) {
      return result;
    }, function () {
      return mapService.getCredentials(env).then(function (credential) {
        params = _.extend(params || {}, {
          key: credential,
          output: 'json'
        });
        var options = {
          url: getMapLocationApiUrl(search),
          dataType: 'jsonp',
          jsonp: 'jsonp',
          data: params
        };
        return $.ajax(options).then(
          function (result, status, object) {
            if (result.resourceSets[0].resources[0]) {
              var coordinates = {
                Latitude: result.resourceSets[0].resources[0].geocodePoints[0].coordinates[0],
                Longitude: result.resourceSets[0].resources[0].geocodePoints[0].coordinates[1]
              };
              mapCacheService.set(search, coordinates);
              return coordinates;
            }
          }
        );
      });
    }
  );
};

mapService.icons = {
  fnac: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" width="30" height="40"><path d="M15 0C6.7 0 0 6.8 0 15.3 0 23.7 8.4 32.9 15 40c6.6-7.1 15-16.3 15-24.8S23.3 0 15 0z" style="fill:#232323"/><path d="M4.1 17.7h1.5v-4.3h2.6v4.3h1.5v-3.1c.1-.5.4-1.2 1.6-1.3 0 0 1.7-.3 1.9 1.3v3.1h1.5V14c-.3-2.6-3.7-1.8-3.7-1.8-.8.2-1.1.6-1.2.8v-.7H5.6c-.1-1.4 1.2-1.4 1.2-1.4 1.3 0 1.4.9 1.4.9h1.5c0-1.7-2.1-1.9-2.1-1.9-2.1-.2-2.8.6-2.8.6-.7.5-.7 1.5-.7 1.7H2.8v1.1h1.3v4.4zm15.3-1.5c-.4.5-.8.6-1.4.7-.5 0-1.4.1-1.5-.7 0-.8 1.2-.7 2-.8 0 0 .8 0 1-.2.1-.1.2.6-.1 1m0-4c-1.6-.3-2.6 0-2.6 0-1.6.4-1.6 1.8-1.6 1.8h1.5s0-1.1 1.6-1c0 0 1.2.1 1.2.6 0 0 .4.7-1.2.8-1.6.1-3.6.1-3.4 1.7 0 0 0 1.6 2.6 1.5 0 0 1.4 0 2-.7l.1.6h1.5v-3.3c.1-1.7-1.7-2-1.7-2m6.9 3.7c-.2.5-.7.8-1.5.8 0 0-1.8.1-1.9-1.7v-.1c.1-1.8 1.9-1.7 1.9-1.7.8 0 1.3.3 1.5.8h1.5c0-.3-.2-.6-.2-.6-.4-.6-1.2-1.4-3.2-1.2-.6 0-1 .1-1.3.2-.7.3-1.8 1-1.7 2.5v.2c0 1.4 1.1 2.2 1.7 2.5.4.2.8.2 1.3.2 1.3.1 2.2-.2 2.7-.6.7-.6.7-1.3.7-1.3h-1.5z" style="fill:#FFFFFF"/></svg>',
  fnacSelected: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" width="30" height="40"><path d="M15 0C6.7 0 0 6.8 0 15.3 0 23.7 8.4 32.9 15 40c6.6-7.1 15-16.3 15-24.8S23.3 0 15 0z" style="fill:#F5B027"/><path d="M4.1 17.7h1.5v-4.3h2.6v4.3h1.5v-3.1c.1-.5.4-1.2 1.6-1.3 0 0 1.7-.3 1.9 1.3v3.1h1.5V14c-.3-2.6-3.7-1.8-3.7-1.8-.8.2-1.1.6-1.2.8v-.7H5.6c-.1-1.4 1.2-1.4 1.2-1.4 1.3 0 1.4.9 1.4.9h1.5c0-1.7-2.1-1.9-2.1-1.9-2.1-.2-2.8.6-2.8.6-.7.5-.7 1.5-.7 1.7H2.8v1.1h1.3v4.4zm15.3-1.5c-.4.5-.8.6-1.4.7-.5 0-1.4.1-1.5-.7 0-.8 1.2-.7 2-.8 0 0 .8 0 1-.2.1-.1.2.6-.1 1m0-4c-1.6-.3-2.6 0-2.6 0-1.6.4-1.6 1.8-1.6 1.8h1.5s0-1.1 1.6-1c0 0 1.2.1 1.2.6 0 0 .4.7-1.2.8-1.6.1-3.6.1-3.4 1.7 0 0 0 1.6 2.6 1.5 0 0 1.4 0 2-.7l.1.6h1.5v-3.3c.1-1.7-1.7-2-1.7-2m6.9 3.7c-.2.5-.7.8-1.5.8 0 0-1.8.1-1.9-1.7v-.1c.1-1.8 1.9-1.7 1.9-1.7.8 0 1.3.3 1.5.8h1.5c0-.3-.2-.6-.2-.6-.4-.6-1.2-1.4-3.2-1.2-.6 0-1 .1-1.3.2-.7.3-1.8 1-1.7 2.5v.2c0 1.4 1.1 2.2 1.7 2.5.4.2.8.2 1.3.2 1.3.1 2.2-.2 2.7-.6.7-.6.7-1.3.7-1.3h-1.5z" style="fill:#FFFFFF"/></svg>',
  darty: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="40px" viewBox="424.37 305.985 30 40" enable-background="new 424.37 305.985 30 40" xml:space="preserve"><path fill="#EE252E" d="M439.37,305.985c-8.301,0-15,6.8-15,15.3c0,8.399,8.4,17.601,15,24.7c6.6-7.1,15-16.301,15-24.8C454.37,312.684,447.67,305.985,439.37,305.985z"/><ellipse fill="#231F20" cx="439.453" cy="320.651" rx="11.833" ry="11.167"/><path fill="#FFFFFF" d="M430.47,318.784v3.8c0,0,0.9,0.2,0.9-1.9C431.37,318.584,430.47,318.784,430.47,318.784L430.47,318.784zM435.47,318.784l-0.4,2.2h0.8 M439.869,318.584v1.7c0,0,0.701,0,0.701-0.8C440.57,318.584,439.869,318.584,439.869,318.584z"/><path fill="#FFFFFF" d="M439.37,309.285c-6.601,0-12,5.2-12,11.5s5.4,11.5,12,11.5c6.6,0,11.999-5.1,11.999-11.5	C451.369,314.485,445.97,309.285,439.37,309.285z M430.87,323.884h-2.3c0,0,0.2-1.399,0.2-3.199c0-1.8-0.2-3.2-0.2-3.2h2.3	c0.8,0,2.1,0.5,2.1,3.2S431.669,323.884,430.87,323.884z M449.27,323.884h-2c0,0,0.199-1.499-0.2-3.199c-0.299-1.3-0.899-2.6-1.1-3	v1.3c-0.5-0.2-1.1-0.2-1.1-0.2v2.3l0.199,2.9h-2c0,0,0.1-1.7,0.2-2.9c0.101-1.1,0-2.3,0-2.3c-0.5,0-0.9,0.1-1,0.2v0.4c0,1.4-1.101,1.8-1.101,1.8s0.301,0.4,0.7,1.2c0.5,0.8,0.801,1.6,0.801,1.6h-2.2c0,0,0-0.399-0.2-1.1c-0.199-0.7-0.5-1.1-0.5-1.1s-0.1,0.4,0,1.1c0.1,0.701,0.2,1.1,0.2,1.1h-3.9v-0.8c-0.1-0.5-0.2-0.9-0.2-0.9h-1c0,0-0.101,0.3-0.2,0.8c-0.1,0.6,0,0.799,0,0.799h-2c0,0,0.5-1.699,0.8-3.199c0.3-1.5,0.5-3.2,0.5-3.2h2.9c0,0,0.2,1.7,0.5,3.2c0.2,1,0.501,2.1,0.7,2.7c0.1-0.5,0.1-1.4,0.1-2.7c0-2-0.199-3.2-0.199-3.2h2.9c0.299,0,1.099,0.2,1.399,1.1v-1.1h5.6l0.501,1.9l0.5-1.9h1.899c0,0-0.8,1.6-1.199,3.2C449.07,322.385,449.27,323.884,449.27,323.884z"/></svg>',
  dartySelected: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="40px" viewBox="424.37 305.985 30 40" enable-background="new 424.37 305.985 30 40" xml:space="preserve"><path fill="#EE252E" d="M439.37,305.985c-8.301,0-15,6.8-15,15.3c0,8.399,8.4,17.601,15,24.7c6.6-7.1,15-16.301,15-24.8	C454.37,312.684,447.67,305.985,439.37,305.985z"/><ellipse fill="#FFFFFF" cx="439.453" cy="320.651" rx="11.833" ry="11.168"/><path fill="#EE252E" d="M430.47,318.784v3.8c0,0,0.9,0.2,0.9-1.9C431.37,318.584,430.47,318.784,430.47,318.784L430.47,318.784zM435.47,318.784l-0.4,2.2h0.8 M439.869,318.584v1.7c0,0,0.701,0,0.701-0.8C440.57,318.584,439.869,318.584,439.869,318.584z"/><path fill="#EE252E" d="M439.37,309.285c-6.601,0-12,5.2-12,11.5s5.4,11.5,12,11.5c6.6,0,11.999-5.1,11.999-11.5C451.369,314.485,445.97,309.285,439.37,309.285z M430.87,323.884h-2.3c0,0,0.2-1.399,0.2-3.199c0-1.8-0.2-3.2-0.2-3.2h2.3c0.8,0,2.1,0.5,2.1,3.2S431.669,323.884,430.87,323.884z M449.27,323.884h-2c0,0,0.199-1.499-0.2-3.199c-0.299-1.3-0.899-2.6-1.1-3v1.3c-0.5-0.2-1.1-0.2-1.1-0.2v2.3l0.199,2.9h-2c0,0,0.1-1.7,0.2-2.9c0.101-1.1,0-2.3,0-2.3c-0.5,0-0.9,0.1-1,0.2v0.4c0,1.4-1.101,1.8-1.101,1.8s0.301,0.4,0.7,1.2c0.5,0.8,0.801,1.6,0.801,1.6h-2.2c0,0,0-0.399-0.2-1.1c-0.199-0.7-0.5-1.1-0.5-1.1s-0.1,0.4,0,1.1c0.1,0.701,0.2,1.1,0.2,1.1h-3.9v-0.8c-0.1-0.5-0.2-0.9-0.2-0.9h-1c0,0-0.101,0.3-0.2,0.8c-0.1,0.6,0,0.799,0,0.799h-2c0,0,0.5-1.699,0.8-3.199c0.3-1.5,0.5-3.2,0.5-3.2h2.9c0,0,0.2,1.7,0.5,3.2c0.2,1,0.501,2.1,0.7,2.7c0.1-0.5,0.1-1.4,0.1-2.7c0-2-0.199-3.2-0.199-3.2h2.9c0.299,0,1.099,0.2,1.399,1.1v-1.1h5.6l0.501,1.9l0.5-1.9h1.899c0,0-0.8,1.6-1.199,3.2C449.07,322.385,449.27,323.884,449.27,323.884z"/></svg>',
  fnacRelay: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" width="30" height="40"><path d="M15 0C6.7 0 0 6.8 0 15.3 0 23.7 8.4 32.9 15 40c6.6-7.1 15-16.3 15-24.8S23.3 0 15 0z" style="fill:#232323"/><path d="M14 5.5L6.5 9.9V19l9.4 5.5 7.6-4.4V11L14 5.5zm7.5 5.9l-2.1 1.1L12 8.1 14 7l7.5 4.4zm-6.3 11l-7.4-4.3v-6.7l7.4 4.3v6.7zm.7-7.9l-7.3-4.3L10.7 9l7.3 4.3-2.1 1.2zm6.2 4.8l-5.5 3.2v-6.8l5.5-3.1v6.7z" style="fill:#FFFFFF"/></svg>',
  fnacRelaySelected: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" width="30" height="40"><path d="M15 0C6.7 0 0 6.8 0 15.3 0 23.7 8.4 32.9 15 40c6.6-7.1 15-16.3 15-24.8S23.3 0 15 0z" style="fill:#F5B027"/><path d="M14 5.5L6.5 9.9V19l9.4 5.5 7.6-4.4V11L14 5.5zm7.5 5.9l-2.1 1.1L12 8.1 14 7l7.5 4.4zm-6.3 11l-7.4-4.3v-6.7l7.4 4.3v6.7zm.7-7.9l-7.3-4.3L10.7 9l7.3 4.3-2.1 1.2zm6.2 4.8l-5.5 3.2v-6.8l5.5-3.1v6.7z" style="fill:#FFFFFF"/></svg>'
};

// @todo: refactor this
mapService.icon = function (options) {
  var icon = null;

  if (options.organization === 0) {
    options.organization = 'fnac';
  }

  // by default we return 'unselected fnac icon'
  var defaultOptions = {
    organization: 'fnac', // can be 'fnac' or 'darty'
    type: 'shop',         // can be 'shop' or 'relay'
    selected: false       // can be true or false
  };

  options = options || {};
  options = $.extend(defaultOptions, options);

  if (options.type === 'shop') {
    if (options.organization === 'fnac') {
      icon = options.selected ? mapService.icons.fnacSelected : mapService.icons.fnac;
    } else {
      icon = options.selected ? mapService.icons.dartySelected : mapService.icons.darty;
    }
  } else {
    icon = options.selected ? mapService.icons.fnacRelaySelected : mapService.icons.fnacRelay;
  }

  return icon;
};
